<template>
  <div class="main-layout h-100">
    <div class="d-flex flex-column h-100 w-100">
      <div id="content" class="h-100">
        <div class="left-column-section overflow-auto h-100">
          <!-- Replace LeftMenu with desired content/component(s) -->
          <LeftMenu />
        </div> 
      <div class="main-content">
          <Child />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftMenu from './Subcomponents/LeftMenu'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ThreeColumnLayout',

  components: {
    LeftMenu
  },
  computed: {
    ...mapState('events', ['pageEvents', 'eventsLoaded']),
    path: function(){
      return this.$route.name
    }
  },
  watch : {
    path: function() {
      this.checkForPageWatch()
    },
    eventsLoaded: function(newValue, oldValue) {
      if (!oldValue && newValue) {
        this.checkForPageWatch()
      }
    }
  },
  methods: {
    ...mapActions('events', ['processEvent', 'clearPageWatch']),
    checkForPageWatch: function() {
      if (this.pageEvents.get(this.path)){
        this.processEvent({ eventId: this.pageEvents.get(this.path) })
        this.clearPageWatch({ page: this.path })
      }
    }
  },
  created: function() {
  }
}
</script>
<style>
body {
  background-color: var(--background-gray);
}
</style>
<style scoped lang="scss">
.main-layout{
  width: 100%;
  min-height: 100%;
  background-color: var(--background-gray);
  overflow-y: auto;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  display: flex;
}

#content {
  flex: 1;
  display: grid;
  grid-template-areas:
  'left-column main-content';
  grid-template-columns: 250px auto;
}

.left-column-section {
  grid-area: left-column;
  height: 100%;
  overflow-y: auto;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.main-content {
  grid-area: main-content;
  flex: 1;
}
</style>
